import type { Country } from './types';

/**
 * African countries with full metadata.
 */
export const africaCountries: Country[] = [
  {
    code: 'ZA',
    name: 'South Africa',
    flag: '\u{1F1FF}\u{1F1E6}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Pretoria',
      population: '60.0M',
      currency: 'ZAR (R)',
      languages: 'Afrikaans, English, Zulu, Xhosa',
      area: '1,221,037 km\u00B2',
    },
  },
  {
    code: 'EG',
    name: 'Egypt',
    flag: '\u{1F1EA}\u{1F1EC}',
    continent: 'Africa',
    subregion: 'North Africa',
    details: {
      capital: 'Cairo',
      population: '104.3M',
      currency: 'EGP (\u00A3)',
      languages: 'Arabic',
      area: '1,002,450 km\u00B2',
    },
  },
  {
    code: 'MA',
    name: 'Morocco',
    flag: '\u{1F1F2}\u{1F1E6}',
    continent: 'Africa',
    subregion: 'North Africa',
    details: {
      capital: 'Rabat',
      population: '37.3M',
      currency: 'MAD (\u062F.\u0645.)',
      languages: 'Arabic, Berber',
      area: '446,550 km\u00B2',
    },
  },
  {
    code: 'KE',
    name: 'Kenya',
    flag: '\u{1F1F0}\u{1F1EA}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Nairobi',
      population: '54.0M',
      currency: 'KES (KSh)',
      languages: 'Swahili, English',
      area: '580,367 km\u00B2',
    },
  },
  {
    code: 'NG',
    name: 'Nigeria',
    flag: '\u{1F1F3}\u{1F1EC}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Abuja',
      population: '218.5M',
      currency: 'NGN (\u20A6)',
      languages: 'English',
      area: '923,768 km\u00B2',
    },
  },
  {
    code: 'GH',
    name: 'Ghana',
    flag: '\u{1F1EC}\u{1F1ED}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Accra',
      population: '32.8M',
      currency: 'GHS (\u20B5)',
      languages: 'English',
      area: '238,533 km\u00B2',
    },
  },
  {
    code: 'TZ',
    name: 'Tanzania',
    flag: '\u{1F1F9}\u{1F1FF}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Dodoma',
      population: '63.6M',
      currency: 'TZS (TSh)',
      languages: 'Swahili, English',
      area: '947,303 km\u00B2',
    },
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    flag: '\u{1F1EA}\u{1F1F9}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Addis Ababa',
      population: '120.3M',
      currency: 'ETB (Br)',
      languages: 'Amharic',
      area: '1,104,300 km\u00B2',
    },
  },
  {
    code: 'RW',
    name: 'Rwanda',
    flag: '\u{1F1F7}\u{1F1FC}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Kigali',
      population: '13.5M',
      currency: 'RWF (FRw)',
      languages: 'Kinyarwanda, English, French',
      area: '26,338 km\u00B2',
    },
  },
  {
    code: 'UG',
    name: 'Uganda',
    flag: '\u{1F1FA}\u{1F1EC}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Kampala',
      population: '47.2M',
      currency: 'UGX (USh)',
      languages: 'English, Swahili',
      area: '241,038 km\u00B2',
    },
  },
  {
    code: 'DZ',
    name: 'Algeria',
    flag: '\u{1F1E9}\u{1F1FF}',
    continent: 'Africa',
    subregion: 'North Africa',
    details: {
      capital: 'Algiers',
      population: '44.9M',
      currency: 'DZD (\u062F.\u062C)',
      languages: 'Arabic, Berber',
      area: '2,381,741 km\u00B2',
    },
  },
  {
    code: 'TN',
    name: 'Tunisia',
    flag: '\u{1F1F9}\u{1F1F3}',
    continent: 'Africa',
    subregion: 'North Africa',
    details: {
      capital: 'Tunis',
      population: '12.0M',
      currency: 'TND (\u062F.\u062A)',
      languages: 'Arabic',
      area: '163,610 km\u00B2',
    },
  },
  {
    code: 'SN',
    name: 'Senegal',
    flag: '\u{1F1F8}\u{1F1F3}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Dakar',
      population: '17.2M',
      currency: 'XOF (CFA)',
      languages: 'French',
      area: '196,722 km\u00B2',
    },
  },
  {
    code: 'CI',
    name: 'Ivory Coast',
    officialName: "C\u00F4te d'Ivoire",
    flag: '\u{1F1E8}\u{1F1EE}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Yamoussoukro',
      population: '27.5M',
      currency: 'XOF (CFA)',
      languages: 'French',
      area: '322,463 km\u00B2',
    },
    mapHints: {
      nameInAtlas: "C\u00F4te d'Ivoire",
    },
  },
  {
    code: 'CM',
    name: 'Cameroon',
    flag: '\u{1F1E8}\u{1F1F2}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: 'Yaound\u00E9',
      population: '27.9M',
      currency: 'XAF (CFA)',
      languages: 'French, English',
      area: '475,442 km\u00B2',
    },
  },
  {
    code: 'AO',
    name: 'Angola',
    flag: '\u{1F1E6}\u{1F1F4}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Luanda',
      population: '34.5M',
      currency: 'AOA (Kz)',
      languages: 'Portuguese',
      area: '1,246,700 km\u00B2',
    },
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    flag: '\u{1F1F2}\u{1F1FF}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Maputo',
      population: '32.1M',
      currency: 'MZN (MT)',
      languages: 'Portuguese',
      area: '801,590 km\u00B2',
    },
  },
  {
    code: 'ZM',
    name: 'Zambia',
    flag: '\u{1F1FF}\u{1F1F2}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Lusaka',
      population: '19.5M',
      currency: 'ZMW (ZK)',
      languages: 'English',
      area: '752,612 km\u00B2',
    },
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    flag: '\u{1F1FF}\u{1F1FC}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Harare',
      population: '16.0M',
      currency: 'ZWL ($)',
      languages: 'English, Shona, Ndebele',
      area: '390,757 km\u00B2',
    },
  },
  {
    code: 'BW',
    name: 'Botswana',
    flag: '\u{1F1E7}\u{1F1FC}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Gaborone',
      population: '2.4M',
      currency: 'BWP (P)',
      languages: 'English, Tswana',
      area: '581,730 km\u00B2',
    },
  },
  {
    code: 'NA',
    name: 'Namibia',
    flag: '\u{1F1F3}\u{1F1E6}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Windhoek',
      population: '2.5M',
      currency: 'NAD ($)',
      languages: 'English',
      area: '825,615 km\u00B2',
    },
  },
  {
    code: 'MU',
    name: 'Mauritius',
    flag: '\u{1F1F2}\u{1F1FA}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Port Louis',
      population: '1.3M',
      currency: 'MUR (\u20A8)',
      languages: 'English, French, Creole',
      area: '2,040 km\u00B2',
    },
  },
  {
    code: 'SC',
    name: 'Seychelles',
    flag: '\u{1F1F8}\u{1F1E8}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Victoria',
      population: '99K',
      currency: 'SCR (\u20A8)',
      languages: 'English, French, Creole',
      area: '459 km\u00B2',
    },
  },
  {
    code: 'MG',
    name: 'Madagascar',
    flag: '\u{1F1F2}\u{1F1EC}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Antananarivo',
      population: '29.2M',
      currency: 'MGA (Ar)',
      languages: 'Malagasy, French',
      area: '587,041 km\u00B2',
    },
  },
  {
    code: 'CV',
    name: 'Cape Verde',
    officialName: 'Cabo Verde',
    flag: '\u{1F1E8}\u{1F1FB}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Praia',
      population: '593K',
      currency: 'CVE ($)',
      languages: 'Portuguese',
      area: '4,033 km\u00B2',
    },
    mapHints: {
      nameInAtlas: 'Cabo Verde',
    },
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    flag: '\u{1F1EA}\u{1F1ED}',
    continent: 'Africa',
    subregion: 'North Africa',
    details: {
      capital: 'Laayoune',
      population: '597K',
      currency: 'MAD (\u062F.\u0645.)',
      languages: 'Arabic, Spanish',
      area: '266,000 km\u00B2',
    },
    mapHints: {
      nameInAtlas: 'W. Sahara',
    },
  },
  {
    code: 'BJ',
    name: 'Benin',
    flag: '\u{1F1E7}\u{1F1EF}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Porto-Novo',
      population: '13.2M',
      currency: 'XOF (Fr)',
      languages: 'French',
      area: '112,622 km\u00B2',
    },
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    flag: '\u{1F1E7}\u{1F1EB}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Ouagadougou',
      population: '24.1M',
      currency: 'XOF (Fr)',
      languages: 'French',
      area: '272,967 km\u00B2',
    },
  },
  {
    code: 'BI',
    name: 'Burundi',
    flag: '\u{1F1E7}\u{1F1EE}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Gitega',
      population: '12.3M',
      currency: 'BIF (Fr)',
      languages: 'French, Kirundi',
      area: '27,834 km\u00B2',
    },
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    flag: '\u{1F1E8}\u{1F1EB}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: 'Bangui',
      population: '6.5M',
      currency: 'XAF (Fr)',
      languages: 'French, Sango',
      area: '622,984 km\u00B2',
    },
  },
  {
    code: 'TD',
    name: 'Chad',
    flag: '\u{1F1F9}\u{1F1E9}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: "N'Djamena",
      population: '19.3M',
      currency: 'XAF (Fr)',
      languages: 'Arabic, French',
      area: '1,284,000 km\u00B2',
    },
  },
  {
    code: 'KM',
    name: 'Comoros',
    flag: '\u{1F1F0}\u{1F1F2}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Moroni',
      population: '920K',
      currency: 'KMF (Fr)',
      languages: 'Arabic, French',
      area: '1,862 km\u00B2',
    },
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    flag: '\u{1F1E9}\u{1F1EF}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Djibouti',
      population: '1.1M',
      currency: 'DJF (Fr)',
      languages: 'Arabic, French',
      area: '23,200 km\u00B2',
    },
  },
  {
    code: 'CD',
    name: 'DR Congo',
    officialName: 'Democratic Republic of the Congo',
    flag: '\u{1F1E8}\u{1F1E9}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: 'Kinshasa',
      population: '112.8M',
      currency: 'CDF (FC)',
      languages: 'French',
      area: '2,344,858 km\u00B2',
    },
    mapHints: {
      nameInAtlas: 'Dem. Rep. Congo',
    },
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    flag: '\u{1F1EC}\u{1F1F6}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: 'Malabo',
      population: '1.7M',
      currency: 'XAF (Fr)',
      languages: 'French, Portuguese, Spanish',
      area: '28,051 km\u00B2',
    },
    mapHints: {
      nameInAtlas: 'Eq. Guinea',
    },
  },
  {
    code: 'ER',
    name: 'Eritrea',
    flag: '\u{1F1EA}\u{1F1F7}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Asmara',
      population: '3.6M',
      currency: 'ERN (Nfk)',
      languages: 'Arabic, English, Tigrinya',
      area: '117,600 km\u00B2',
    },
  },
  {
    code: 'SZ',
    name: 'Eswatini',
    officialName: 'Kingdom of Eswatini',
    flag: '\u{1F1F8}\u{1F1FF}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Mbabane',
      population: '1.2M',
      currency: 'SZL (L)',
      languages: 'English, Swazi',
      area: '17,364 km\u00B2',
    },
  },
  {
    code: 'GA',
    name: 'Gabon',
    flag: '\u{1F1EC}\u{1F1E6}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: 'Libreville',
      population: '2.5M',
      currency: 'XAF (Fr)',
      languages: 'French',
      area: '267,668 km\u00B2',
    },
  },
  {
    code: 'GM',
    name: 'Gambia',
    flag: '\u{1F1EC}\u{1F1F2}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Banjul',
      population: '2.4M',
      currency: 'GMD (D)',
      languages: 'English',
      area: '10,689 km\u00B2',
    },
  },
  {
    code: 'GN',
    name: 'Guinea',
    flag: '\u{1F1EC}\u{1F1F3}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Conakry',
      population: '14.4M',
      currency: 'GNF (Fr)',
      languages: 'French',
      area: '245,857 km\u00B2',
    },
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    flag: '\u{1F1EC}\u{1F1FC}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Bissau',
      population: '1.8M',
      currency: 'XOF (Fr)',
      languages: 'Portuguese',
      area: '36,125 km\u00B2',
    },
  },
  {
    code: 'LS',
    name: 'Lesotho',
    flag: '\u{1F1F1}\u{1F1F8}',
    continent: 'Africa',
    subregion: 'Southern Africa',
    details: {
      capital: 'Maseru',
      population: '2.1M',
      currency: 'LSL (L)',
      languages: 'English, Sotho',
      area: '30,355 km\u00B2',
    },
  },
  {
    code: 'LR',
    name: 'Liberia',
    flag: '\u{1F1F1}\u{1F1F7}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Monrovia',
      population: '5.2M',
      currency: 'LRD ($)',
      languages: 'English',
      area: '111,369 km\u00B2',
    },
  },
  {
    code: 'LY',
    name: 'Libya',
    flag: '\u{1F1F1}\u{1F1FE}',
    continent: 'Africa',
    subregion: 'North Africa',
    details: {
      capital: 'Tripoli',
      population: '7.5M',
      currency: 'LYD (\u0644.\u062F)',
      languages: 'Arabic',
      area: '1,759,540 km\u00B2',
    },
  },
  {
    code: 'MW',
    name: 'Malawi',
    flag: '\u{1F1F2}\u{1F1FC}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Lilongwe',
      population: '20.7M',
      currency: 'MWK (MK)',
      languages: 'English, Chewa',
      area: '118,484 km\u00B2',
    },
  },
  {
    code: 'ML',
    name: 'Mali',
    flag: '\u{1F1F2}\u{1F1F1}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Bamako',
      population: '22.4M',
      currency: 'XOF (Fr)',
      languages: 'French',
      area: '1,240,192 km\u00B2',
    },
  },
  {
    code: 'MR',
    name: 'Mauritania',
    flag: '\u{1F1F2}\u{1F1F7}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Nouakchott',
      population: '4.9M',
      currency: 'MRU (UM)',
      languages: 'Arabic',
      area: '1,030,700 km\u00B2',
    },
  },
  {
    code: 'NE',
    name: 'Niger',
    flag: '\u{1F1F3}\u{1F1EA}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Niamey',
      population: '26.3M',
      currency: 'XOF (Fr)',
      languages: 'French',
      area: '1,267,000 km\u00B2',
    },
  },
  {
    code: 'CG',
    name: 'Republic of the Congo',
    flag: '\u{1F1E8}\u{1F1EC}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: 'Brazzaville',
      population: '6.1M',
      currency: 'XAF (Fr)',
      languages: 'French',
      area: '342,000 km\u00B2',
    },
    mapHints: {
      nameInAtlas: 'Congo',
    },
  },
  {
    code: 'ST',
    name: 'S\u00E3o Tom\u00E9 and Pr\u00EDncipe',
    flag: '\u{1F1F8}\u{1F1F9}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: 'S\u00E3o Tom\u00E9',
      population: '210K',
      currency: 'STN (Db)',
      languages: 'Portuguese',
      area: '964 km\u00B2',
    },
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    flag: '\u{1F1F8}\u{1F1F1}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Freetown',
      population: '9.1M',
      currency: 'SLE (Le)',
      languages: 'English',
      area: '71,740 km\u00B2',
    },
  },
  {
    code: 'SO',
    name: 'Somalia',
    flag: '\u{1F1F8}\u{1F1F4}',
    continent: 'Africa',
    subregion: 'East Africa',
    details: {
      capital: 'Mogadishu',
      population: '19.7M',
      currency: 'SOS (Sh)',
      languages: 'Arabic, Somali',
      area: '637,657 km\u00B2',
    },
  },
  {
    code: 'SS',
    name: 'South Sudan',
    flag: '\u{1F1F8}\u{1F1F8}',
    continent: 'Africa',
    subregion: 'Central Africa',
    details: {
      capital: 'Juba',
      population: '15.8M',
      currency: 'SSP (\u00A3)',
      languages: 'English',
      area: '619,745 km\u00B2',
    },
  },
  {
    code: 'SD',
    name: 'Sudan',
    flag: '\u{1F1F8}\u{1F1E9}',
    continent: 'Africa',
    subregion: 'North Africa',
    details: {
      capital: 'Khartoum',
      population: '51.7M',
      currency: 'SDG (\u062C.\u0633)',
      languages: 'Arabic, English',
      area: '1,886,068 km\u00B2',
    },
  },
  {
    code: 'TG',
    name: 'Togo',
    flag: '\u{1F1F9}\u{1F1EC}',
    continent: 'Africa',
    subregion: 'West Africa',
    details: {
      capital: 'Lom\u00E9',
      population: '8.1M',
      currency: 'XOF (Fr)',
      languages: 'French',
      area: '56,785 km\u00B2',
    },
  },
];
